module.exports = __webpack_public_path__ + "static/media/honey_rush_100.playngo.e0a495f2.jpeg";